import { useEffect, useState } from 'react'
import { serverNow as xoxServerNow } from '../store/room'

/**
 * Remaining ms until a server deadline, refreshed a few times per second. Each room store keeps
 * its own clock offset, so games other than XOX pass theirs.
 */
export function useCountdown(
  deadlineAt: number | null,
  serverNow: () => number = xoxServerNow,
): number | null {
  const [remaining, setRemaining] = useState<number | null>(null)
  useEffect(() => {
    if (deadlineAt === null) {
      setRemaining(null)
      return
    }
    const tick = () => setRemaining(Math.max(0, deadlineAt - serverNow()))
    tick()
    const id = setInterval(tick, 200)
    return () => clearInterval(id)
  }, [deadlineAt, serverNow])
  return remaining
}
